import { useEffect, useState, memo } from 'react';
import KnowledgePointsRender, { IKnowledgePointsRenderProps } from '@/sub-luca-plugin/components/knowledge-points-render';
import { eventBusExample } from '@/sub-luca-plugin/utils/class-example';
import { useControlDrawerTransform } from '@/sub-luca-plugin/utils/custom-hooks';
import { INoticeData } from '@/sub-luca-plugin/types';
import './index.scss';

const KnowledgePointsDrawer = () => {
    const [params, setParams] = useState<IKnowledgePointsRenderProps>({});
    const { showDrawer, hideDrawer, style } = useControlDrawerTransform({ isFlex: true });

    const handleClose = () => {
        hideDrawer();
        setTimeout(() => setParams({}), 500);
    };

    useEffect(() => {
        eventBusExample.subscribe('KnowledgePointsDrawer', ({ type, params = {} }: INoticeData) => {
            const { title, content, recordId, projectId, subjectId, twoLevelSubjectId } = params;
            switch (type) {
                case 'open':
                    setParams({ title, content, recordId, projectId, subjectId, twoLevelSubjectId });
                    showDrawer();
                    break;
                default:
                    handleClose();
                    break;
            }
        });
    }, []);

    return (
        <div className="knowledge-points-drawer" style={style}>
            <KnowledgePointsRender {...params} onClose={handleClose} />
        </div>
    );
};

export default memo(KnowledgePointsDrawer);
